import { render, staticRenderFns } from "./UserBalanceBalancesAddBalanceModal.vue?vue&type=template&id=1603f79e&"
import script from "./UserBalanceBalancesAddBalanceModal.vue?vue&type=script&lang=js&"
export * from "./UserBalanceBalancesAddBalanceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports